var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { useQuery } from "react-query";
import { Box, Divider, Grid, IconButton, Link, Paper, Typography, } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ArrowForward, CloudUpload, Headset, Person, PlayArrow, SettingsInputAntenna, } from "@material-ui/icons";
import { Link as RouterLink } from "react-router-dom";
import { usePlaylists } from "frontend/src/domain/playlists/selectors";
import { useViewer } from "frontend/src/domain/session";
import { useTimetables } from "frontend/src/domain/timetables";
import { getWebSchedules } from "frontend/src/api/web-schedules";
import { useViewerAdvertisements } from "frontend/src/domain/audio-advertisements";
import { paths } from "frontend/src/pages/paths/index";
import { BusinessOwnerLayout } from "frontend/src/pages/layouts";
import { playPlaylistAttempted } from "frontend/src/features/play-playlist";
var path = paths.business.owner;
var useStyles = makeStyles(function (theme) { return ({
    intro: {
        marginBottom: theme.spacing(3),
        color: theme.palette.type === "dark" ? "#fff" : "#2f343b",
        textShadow: "0 2px 18px rgba(0, 0, 0, 0.34)",
        "& .MuiTypography-colorTextSecondary": {
            color: theme.palette.type === "dark"
                ? "rgba(255, 255, 255, 0.78)"
                : "rgba(47, 52, 59, 0.7)",
        },
    },
    tileLink: {
        display: "block",
    },
    sectionTile: {
        display: "flex",
        flexDirection: "column",
        aspectRatio: "1 / 1",
        padding: theme.spacing(2.5),
        borderRadius: 8,
        border: "1px solid rgba(255, 255, 255, 0.24)",
        boxShadow: "none",
        transition: "border-color 160ms ease, transform 160ms ease",
        "&:hover": {
            borderColor: "rgba(255, 255, 255, 0.46)",
            transform: "translateY(-1px)",
        },
    },
    sectionHeader: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: theme.spacing(2),
    },
    iconWrap: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 42,
        height: 42,
        borderRadius: 8,
        color: theme.palette.type === "dark"
            ? "rgba(255, 255, 255, 0.9)"
            : "rgba(47, 52, 59, 0.82)",
        backgroundColor: "rgba(255, 255, 255, 0.1)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
    },
    arrow: {
        color: theme.palette.type === "dark"
            ? "rgba(255, 255, 255, 0.78)"
            : "rgba(47, 52, 59, 0.68)",
    },
    metric: {
        marginTop: "auto",
        color: theme.palette.type === "dark"
            ? "rgba(255, 255, 255, 0.78)"
            : "rgba(47, 52, 59, 0.68)",
    },
    previewList: {
        marginTop: theme.spacing(1),
        borderRadius: 8,
        border: "1px solid rgba(255, 255, 255, 0.22)",
        boxShadow: "none",
        overflow: "hidden",
    },
    previewRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        minHeight: 54,
        padding: theme.spacing(1.25, 1.5),
        color: theme.palette.type === "dark" ? "#fff" : "#2f343b",
        "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.08)",
        },
    },
    previewMeta: {
        display: "flex",
        alignItems: "center",
        marginTop: 2,
        color: theme.palette.type === "dark"
            ? "rgba(255, 255, 255, 0.68)"
            : "rgba(47, 52, 59, 0.64)",
    },
    previewPlayButton: {
        marginLeft: theme.spacing(1),
        flexShrink: 0,
    },
    previewEmpty: {
        padding: theme.spacing(1.5),
        color: theme.palette.type === "dark"
            ? "rgba(255, 255, 255, 0.68)"
            : "rgba(47, 52, 59, 0.64)",
    },
}); });
var getCountText = function (count, loading) {
    if (loading) {
        return "Загрузка";
    }
    if (count === undefined) {
        return "Нет данных";
    }
    return "" + count;
};
var getPlaylistMeta = function (trackCount, duration) {
    if (trackCount === 0 && duration !== "00:00" && duration !== "00:00:00") {
        return duration;
    }
    return trackCount + " \u0442\u0440\u0435\u043A\u043E\u0432, " + duration;
};
var SectionTile = function (_a) {
    var name = _a.name, caption = _a.caption, url = _a.url, icon = _a.icon, count = _a.count, loading = _a.loading;
    var classes = useStyles();
    return (React.createElement(Link, { component: RouterLink, to: url, underline: "none", color: "inherit", className: classes.tileLink },
        React.createElement(Paper, { className: classes.sectionTile },
            React.createElement(Box, { className: classes.sectionHeader },
                React.createElement(Box, { className: classes.iconWrap }, icon),
                React.createElement(ArrowForward, { fontSize: "small", className: classes.arrow })),
            React.createElement(Typography, { variant: "h6", component: "h2" }, name),
            React.createElement(Box, { mt: 0.75, mb: 3 },
                React.createElement(Typography, { variant: "body2", color: "textSecondary" }, caption)),
            React.createElement(Typography, { variant: "body2", className: classes.metric }, getCountText(count, loading)))));
};
var PreviewList = function (_a) {
    var loading = _a.loading, emptyText = _a.emptyText, items = _a.items;
    var classes = useStyles();
    if (loading) {
        return (React.createElement(Paper, { className: classes.previewList },
            React.createElement(Typography, { variant: "body2", className: classes.previewEmpty }, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430")));
    }
    if (items.length === 0) {
        return (React.createElement(Paper, { className: classes.previewList },
            React.createElement(Typography, { variant: "body2", className: classes.previewEmpty }, emptyText)));
    }
    return (React.createElement(Paper, { className: classes.previewList }, items.map(function (item, index) {
        var play = function (event) {
            var _a;
            event.preventDefault();
            event.stopPropagation();
            (_a = item.onPlay) === null || _a === void 0 ? void 0 : _a.call(item);
        };
        return (React.createElement(React.Fragment, { key: item.url + "-" + item.title },
            index > 0 && React.createElement(Divider, null),
            React.createElement(Link, { component: RouterLink, to: item.url, underline: "none", color: "inherit", className: classes.previewRow },
                React.createElement(Box, { minWidth: 0 },
                    React.createElement(Typography, { variant: "body2", noWrap: true }, item.title),
                    item.meta && (React.createElement(Typography, { variant: "caption", className: classes.previewMeta }, item.meta))),
                React.createElement(IconButton, { size: "small", className: classes.previewPlayButton, onClick: play, disabled: !item.onPlay },
                    React.createElement(PlayArrow, { fontSize: "small" })))));
    })));
};
export var HomePage = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var classes = useStyles();
    var user = useViewer().user;
    var privatePlaylists = usePlaylists({
        type: "private",
        take: 5,
        skip: 0,
        isPublished: true,
        clientId: user === null || user === void 0 ? void 0 : user.clientId,
        orderBy: "updated_at",
        orderByDirection: "desc",
    });
    var publicPlaylists = usePlaylists({
        type: "public",
        take: 5,
        skip: 0,
        isPublished: true,
        clientId: null,
        orderBy: "order",
        orderByDirection: "asc",
    });
    var timetables = useTimetables();
    var webSchedules = useQuery("web-schedules-dashboard", getWebSchedules);
    var advertisements = useViewerAdvertisements();
    var sections = [
        {
            name: "Мои плейлисты",
            caption: "Собственные подборки для вашего бизнеса",
            url: path.playlists.index("private"),
            icon: React.createElement(Person, null),
            count: (_a = privatePlaylists.data) === null || _a === void 0 ? void 0 : _a.total,
            loading: privatePlaylists.isLoading,
            list: {
                loading: privatePlaylists.isLoading,
                emptyText: "Пока нет своих плейлистов",
                items: (_c = (_b = privatePlaylists.data) === null || _b === void 0 ? void 0 : _b.items.map(function (playlist) { return ({
                    title: playlist.title,
                    url: path.playlists.edit(playlist.id),
                    meta: getPlaylistMeta(playlist.trackCount, playlist.duration.formatted),
                    onPlay: function () {
                        return playPlaylistAttempted({
                            id: playlist.id,
                            title: playlist.title,
                            startAtTrackIndex: 0,
                        });
                    },
                }); })) !== null && _c !== void 0 ? _c : [],
            },
        },
        {
            name: "Плейлисты imstream",
            caption: "Готовые музыкальные подборки сервиса",
            url: path.playlists.index("public"),
            icon: React.createElement(Headset, null),
            count: (_d = publicPlaylists.data) === null || _d === void 0 ? void 0 : _d.total,
            loading: publicPlaylists.isLoading,
            list: {
                loading: publicPlaylists.isLoading,
                emptyText: "Плейлисты imstream не найдены",
                items: (_f = (_e = publicPlaylists.data) === null || _e === void 0 ? void 0 : _e.items.map(function (playlist) { return ({
                    title: playlist.title,
                    url: path.playlists.view(playlist.id),
                    meta: getPlaylistMeta(playlist.trackCount, playlist.duration.formatted),
                    onPlay: function () {
                        return playPlaylistAttempted({
                            id: playlist.id,
                            title: playlist.title,
                            startAtTrackIndex: 0,
                        });
                    },
                }); })) !== null && _f !== void 0 ? _f : [],
            },
        },
        {
            name: "Расписание плейлистов",
            caption: "Настройка музыкального вещания по дням и времени",
            url: path.schedules.index(),
            icon: React.createElement(SettingsInputAntenna, null),
            count: (_g = webSchedules.data) === null || _g === void 0 ? void 0 : _g.length,
            loading: webSchedules.isLoading,
            list: {
                loading: webSchedules.isLoading,
                emptyText: "Пока нет расписаний",
                items: (_j = (_h = webSchedules.data) === null || _h === void 0 ? void 0 : _h.slice(0, 5).map(function (schedule) { return ({
                    title: schedule.title,
                    url: path.schedules.edit(schedule.id),
                }); })) !== null && _j !== void 0 ? _j : [],
            },
        },
        {
            name: "Загруженные файлы",
            caption: "Аудиофайлы и рекламные вставки",
            url: path.files.index(),
            icon: React.createElement(CloudUpload, null),
            count: (_k = advertisements.data) === null || _k === void 0 ? void 0 : _k.length,
            loading: advertisements.isLoading,
            list: {
                loading: advertisements.isLoading,
                emptyText: "Пока нет загруженных файлов",
                items: (_m = (_l = advertisements.data) === null || _l === void 0 ? void 0 : _l.slice(0, 5).map(function (track) { return ({
                    title: track.title,
                    url: path.files.index(),
                    meta: track.duration.formatted,
                }); })) !== null && _m !== void 0 ? _m : [],
            },
        },
    ];
    return (React.createElement(BusinessOwnerLayout, { breadcrumbs: false },
        React.createElement(Box, { className: classes.intro },
            React.createElement(Box, { mt: 1 },
                React.createElement(Typography, { color: "textSecondary" }, "\u0411\u044B\u0441\u0442\u0440\u044B\u0439 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043F\u043B\u0435\u0439\u043B\u0438\u0441\u0442\u0430\u043C, \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044E \u0438 \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043D\u044B\u043C \u0444\u0430\u0439\u043B\u0430\u043C."))),
        React.createElement(Grid, { container: true, spacing: 2 }, sections.map(function (item) { return (React.createElement(Grid, { item: true, xs: 6, sm: 6, lg: 3, key: item.name },
            React.createElement(SectionTile, __assign({}, item)),
            item.list && React.createElement(PreviewList, __assign({}, item.list)))); }))));
};
